/* eslint-disable @next/next/no-img-element */
import { ImageStorageBucket } from "@/utils/Constants";
import { useState } from "react";

function getBackgroundUrl(college_name?: string, country?: string): string {
  if (!college_name || !country) {
    return "/assets/images/png/dummy.png";
  }

  const formattedName = college_name
    .trimEnd()
    .toLocaleLowerCase()
    .replace(/\s+/g, "_")
    .replaceAll(".", "");
  const cleanedCountry = country
    .toLocaleLowerCase()
    .replace(/^europe\s*-\s*/i, "")
    .trim()
    .replace(/\s+/g, "_");

  return `${ImageStorageBucket}/universities1/${cleanedCountry}/${formattedName}/media/${formattedName}_background.webp`;
}

export function ImageBackground({
  college_name,
  country,
  className,
}: {
  college_name: string;
  country: string;
  className?: string;
}) {
  const targetUrl = getBackgroundUrl(college_name, country);
  const [currentSrc, setCurrentSrc] = useState<string>(targetUrl);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={`relative h-full w-full ${className || ""}`}>
      <img
        className="w-full h-full object-cover max-h-full object-center"
        width={1920}
        height={1080}
        src={hasError ? "/assets/images/png/dummy.png" : currentSrc}
        alt={college_name || "University background"}
        loading="eager"
        fetchPriority="high"
        decoding="async"
        onError={() => {
          if (!hasError) {
            setHasError(true);
            setCurrentSrc("/assets/images/png/dummy.png");
          }
        }}
      />
    </div>
  );
}
